module.exports = {
    appPath: 'https://elgcsales.herokuapp.com/',
}


// WEBPACK FOOTER //
// ./src/config/env.js